export default __webpack_public_path__ + "static/media/payment_exist.d1600166.svg";